import { NAV_ITEMS_MODE } from "@/constants";
import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";
import { useFlag } from "@/composables/useFlags/useFlag";
import modules from "./store";

const { isFeatureAvailable: isDashboardAvailableCustomer } = useFlag(
  "DASHBOARD_OVERVIEW_CUSTOMER",
);
const DashboarPlatFormdModule = ({ store, registerNavItems }) => {
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS);
  if (isDashboardAvailableCustomer.value) {
    registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
  }

  store.registerModule("dash_cards", modules.cards);
  store.registerModule("dash_lures", modules.lures);
};

export { DashboarPlatFormdModule };

export default {};
